module.exports = __webpack_public_path__ + "img/whiteFastForge.ccee192e.svg";